import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { linkTextStyle, } from '@/components/ui/Typography/Body/LinkText/style';
/**
 * リンクテキストのコンポーネント
 * NOTE: デザインシステムのルールに基づいてスタイルを設定をしています
 * WARNING: スタイルを変更する場合は、デザインデータの更新必須（none 等は例外）
 * @param props
 * @returns
 */
export const LinkText = (props) => {
    const { children, className = '', isBold, isGroup = false, size = 'md', } = props;
    return (_jsx("span", Object.assign({ className: linkTextStyle({
            class: className,
            isBold,
            isGroup,
            size: size === 'none' ? undefined : size,
        }) }, { children: children })));
};
